import styled from 'styled-components'

export const Box = styled.div`
  display: flex;
  gap: 30px;
`
